import { render, staticRenderFns } from "./evaluations.vue?vue&type=template&id=740ae482&scoped=true"
import script from "./evaluations.vue?vue&type=script&lang=js"
export * from "./evaluations.vue?vue&type=script&lang=js"
import style0 from "./evaluations.vue?vue&type=style&index=0&id=740ae482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740ae482",
  null
  
)

export default component.exports